export var getReviewerNameAndLocationString = function getReviewerNameAndLocationString(reviewerName, reviewerLocation) {
  return "".concat(reviewerName, " ").concat(reviewerLocation ? "(".concat(reviewerLocation, ")") : "");
};